import { Googlesheet } from '../types/generatedContent';

export type TProductMapping = {
  [key: string]: string;
};

export type TProductMappingResponse = {
  durationUnit: string;
  translatedDurationUnit: string;
};

export const getProductMapping = (id: string, content: Googlesheet): TProductMappingResponse | undefined => {
  const { global, products } = content;
  const foundProduct = products.find(
    (product) =>
      product.ids.find((productId) => {
        return id === productId;
      }) !== undefined
  );
  return (
    foundProduct && {
      durationUnit: foundProduct.durationMapping,
      //@ts-ignore
      translatedDurationUnit: global[foundProduct.durationMapping],
    }
  );
};

export enum PROMOTION_TYPES {
  FREE_TRIAL = 'freeTrial',
}
